import { useEffect, useRef } from 'react';

const useActiveSection = (sectionIds: string[]) => {
  const currentHash = useRef<string>('');
  const visibilityMap = useRef<Map<string, number>>(new Map());

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          visibilityMap.current.set(entry.target.id, entry.intersectionRatio);
        });

        let maxRatio = 0;
        let mostVisibleId = '';

        visibilityMap.current.forEach((ratio, id) => {
          if (ratio > maxRatio) {
            maxRatio = ratio;
            mostVisibleId = id;
          }
        });

        if (maxRatio > 0.1 && mostVisibleId) {
          const newHash = `#${mostVisibleId}`;
          if (currentHash.current !== newHash) {
            currentHash.current = newHash;
            window.history.replaceState(null, '', newHash);
          }
        } 
        else if (maxRatio < 0.05 && currentHash.current !== '') {
          currentHash.current = '';
          window.history.replaceState(null, '', window.location.pathname);
        }

        if (window.scrollY < 100 && currentHash.current !== '') {
          currentHash.current = '';
          window.history.replaceState(null, '', window.location.pathname);
        }
      },
      {
        threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
        rootMargin: '-10% 0px -20% 0px' 
      }
    );

    sectionIds.forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        observer.observe(element);
        visibilityMap.current.set(id, 0);
      }
    });

    const handleScroll = () => {
      if (window.scrollY < 100 && currentHash.current !== '') {
        currentHash.current = '';
        window.history.replaceState(null, '', window.location.pathname);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', handleScroll);
      visibilityMap.current.clear();
    };
  }, [sectionIds]);
};

export default useActiveSection;
